import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import { session } from './lib/session';
import { initMotion } from './lib/motion';
import './styles.css';
import './elena.css';
import './v3.css';

session.adoptTokenFromUrl();
initMotion();

const root = document.getElementById('root');
if (!root) throw new Error('#root missing');

createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
